module.exports = __webpack_public_path__ + "static/media/sim-card-image.388e53ec.svg";